<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-login-modal')"><i class="las la-times"></i></button>

        </template>
        <template v-slot:body>
            <div class="container">
                <div class="login-wrapper fadeInDown">
                    <div class="login-content padding-20">
                        <!-- Tabs Titles -->

                        <!-- Icon -->
                        <div class="fadeIn first">
                            <img class="login-logo" src="../../assets/respirayoga-logo.png" alt="Respira Icon" />
                        </div>

                        <!-- Login Form -->
                        <form
                                id="form-login"
                                @submit.prevent="loginWithEmailPassword(email, password)"
                        >
                            <div
                                    v-show="errorMessage"
                                    class="alert alert-danger"
                                    id="modal-error-message"
                                    role="alert"
                            >
                                {{ errorMessage }}
                            </div>
                            <p>
                                <input
                                        type="text"
                                        id="email"
                                        class="form-control"
                                        name="email"
                                        :placeholder="$t('common.email')"
                                        v-model="email"
                                        required
                                />
                            </p>
                            <p>
                                <input
                                        type="password"
                                        id="password"
                                        class="form-control"
                                        name="password"
                                        :placeholder="$t('common.password')"
                                        v-model="password"
                                        required
                                />
                            </p>
                            <input type="submit" class="btn btn-primary btn-lg btn-block" :value="$t('views.login.sign_in')" />
                        </form>
                    </div>
                </div>
                <SpinnerLoader v-show="loading"></SpinnerLoader>
            </div>
        </template>
    </ModalContainer>
</template>

<script>
    import ModalContainer from "./ModalContainer";
    import i18n from "../../i18n"
    import {StorageHelper} from "../../common/storageHelper";
    import {doLoginUser, getUserInfo} from "../../api";
    import SpinnerLoader from "../common/SpinnerLoader";

    export default {
        name: "LoginModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                email: "",
                password: "",
                errorMessage: ""
            }
        },
        components: {ModalContainer, SpinnerLoader},
        methods: {
            async loginWithEmailPassword(username, password) {
                this.loading = true;
                this.errorMessage = "";
                try {
                    const responseLogin = await doLoginUser(username, password);
                    StorageHelper.setTokenConsumer(responseLogin.token);
                    /** User info got by token saved in storage helper*/
                    const responseUser = await getUserInfo();
                    StorageHelper.setUserConsumer(responseUser);
                    /** User must be handler for use manage section */
                    this.loading = false;
                    this.$emit('success-login')
                } catch (e) {
                    this.loading = false;
                    this.errorMessage = i18n.t('views.login.bad_login');
                }
            }
        }
    };
</script>
